import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dynamicdialog',
    templateUrl: './dynamicdialog.component.html',
    styleUrls: ['./dynamicdialog.component.scss'],
    standalone: false
})
export class DynamicdialogComponent implements OnInit {
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {
  }

}
